import React from 'react'
import styles from './TeacherInfo.module.css'

const TeacherInfo = ({ class_teacher_fio, teacher_fio }) => {
  return (
    <div className={styles.teacherInfo}>
      <span>Классный руководитель:&nbsp;<b>{class_teacher_fio}</b></span>
      <span className={styles.sep}>|</span>
      <span>Преподаватель:&nbsp;<b>{teacher_fio}</b></span>
    </div>
  )
}

export default TeacherInfo
